import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getLeadReports = ( params: any) => {
    return axios({
      method: "GET",
      url: "/leads/reports",
        params:{
          ...params,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

export const exportLeadReports = (data: any, params: any) => {
  return axios({
    method: "POST",
    url: `/leads/reports/export`,
    params:{
      ...params,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};